import { useNetworkCounts } from "@/hooks/useDMSocket";

/** Small caramel pill showing unread messages or pending requests in the sidebars. */
export default function NetworkBadge({ kind = "messages", dark = false }) {
  const counts = useNetworkCounts();
  const n = kind === "requests" ? counts.requests : counts.unread_messages;
  if (!n) return null;
  return (
    <span
      className={`ml-auto inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold ${dark ? "bg-[#1A1A1A] text-white" : "bg-[#C68E59] text-white"}`}
      data-testid={`badge-${kind}`}
    >
      {n > 99 ? "99+" : n}
    </span>
  );
}
